import { FileUploadStatus } from '../enums';
import { createSelector } from 'reselect';
import { getFileInfoState } from './getFileInfoState';
import { getThumbnailFileInfo } from './getThumbnailFileInfo';
import { FileHelperService } from '../services';
function mapFileInfoToFile(fileInfo) {
    return {
        fileName: fileInfo.fileName,
        fileSizeInBytes: fileInfo.fileSizeInBytes,
        isUploadFailed: fileInfo.uploadStatus !== FileUploadStatus.SUCCESS,
        id: fileInfo.id,
        docId: fileInfo.docId,
        docUID: fileInfo.docUID
    };
}
export const getAllFiles = createSelector([getFileInfoState], (fileState) => {
    const files = [];
    for (let index = 0; index < fileState.allIds.length; index++) {
        const currentFileInfo = fileState.byId[fileState.allIds[index]];
        if (FileHelperService.isNonCancelledOriginalFile(currentFileInfo)) {
            const file = mapFileInfoToFile(currentFileInfo);
            const thumbnailInfo = getThumbnailFileInfo(fileState, currentFileInfo.id);
            if (thumbnailInfo) {
                file.thumbnail = mapFileInfoToFile(thumbnailInfo);
                file.isUploadFailed = file.thumbnail.isUploadFailed || file.isUploadFailed;
            }
            files.push(file);
        }
    }
    return files;
});
//# sourceMappingURL=getAllFiles.js.map